
(() => {
  const pad = (n) => String(n).padStart(2, '0');

  const UNITS = {
    uk: { day: ['день', 'дні', 'днів'], hour: ['година', 'години', 'годин'],
          minute: ['хвилина', 'хвилини', 'хвилин'], second: ['секунда', 'секунди', 'секунд'] },
    ru: { day: ['день', 'дня', 'дней'], hour: ['час', 'часа', 'часов'],
          minute: ['минута', 'минуты', 'минут'], second: ['секунда', 'секунды', 'секунд'] },
    en: { day: ['day', 'days'], hour: ['hour', 'hours'],
          minute: ['minute', 'minutes'], second: ['second', 'seconds'] },
    pl: { day: ['dzień', 'dni', 'dni'], hour: ['godzina', 'godziny', 'godzin'],
          minute: ['minuta', 'minuty', 'minut'], second: ['sekunda', 'sekundy', 'sekund'] },
    et: { day: ['päev', 'päeva'], hour: ['tund', 'tundi'],
          minute: ['minut', 'minutit'], second: ['sekund', 'sekundit'] },
  };

  const pluralForm = (n, forms, lang) => {
    n = Math.abs(Number(n)) || 0;
    if (lang === 'uk' || lang === 'ru') {
      const a = n % 10, b = n % 100;
      if (a === 1 && b !== 11) return forms[0];
      if (a >= 2 && a <= 4 && (b < 12 || b > 14)) return forms[1];
      return forms[2];
    }
    if (lang === 'pl') {
      const a = n % 10, b = n % 100;
      if (n === 1) return forms[0];
      if (a >= 2 && a <= 4 && !(b >= 12 && b <= 14)) return forms[1];
      return forms[2];
    }
    if (lang === 'en' || lang === 'et') return n === 1 ? forms[0] : forms[1];
    return forms[0];
  };

  const lang = () => {
    const l = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    return UNITS[l] ? l : 'en';
  };
  const unitWord = (unit, n) => {
    const L = lang();
    return pluralForm(n, UNITS[L][unit], L);
  };

  const toMs = (v) => {
    const s = String(v || '').trim();
    if (!s) return NaN;
    return /^\d+$/.test(s) ? Number(s) * 1000 : Date.parse(s);
  };

  const zoneOffset = (tz, ms) => {
    try {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: tz, hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
      }).formatToParts(ms);
      const p = {};
      parts.forEach((x) => { if (x.type !== 'literal') p[x.type] = Number(x.value); });
      const asUTC = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
      return Math.round((asUTC - ms) / 60000) * 60000;
    } catch (_) {
      return null;
    }
  };

  class Countdown {
    constructor(root) {
      this.root = root;
      this.ends = toMs(root.dataset.ends);
      this.starts = root.dataset.starts ? toMs(root.dataset.starts) : null;
      this.tz = root.dataset.tz || '';
      this.cells = {
        days: root.querySelector('.value.days'),
        hours: root.querySelector('.value.hours'),
        minutes: root.querySelector('.value.minutes'),
        seconds: root.querySelector('.value.seconds'),
      };

      const labelOf = (cell) => (cell && cell.closest('.item') ? cell.closest('.item').querySelector('.text') : null);
      this.labels = {
        days: labelOf(this.cells.days), hours: labelOf(this.cells.hours),
        minutes: labelOf(this.cells.minutes), seconds: labelOf(this.cells.seconds),
      };
      if (Number.isNaN(this.ends)) return;

      const now = Date.now();
      if (this.starts && now < this.starts) return;   
      if (now >= this.ends) return this.finish();

      this.root.classList.add('active');
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    finish() {
      clearInterval(this.timer);
      this.root.classList.remove('active');
      this.root.classList.add('countdownOFF');
      this.root.dispatchEvent(new CustomEvent('sale-timer:end', { bubbles: true }));
    }

    wallLeft(now) {
      const left = this.ends - now;
      if (!this.tz) return left;
      const a = zoneOffset(this.tz, now);
      const b = zoneOffset(this.tz, this.ends);
      if (a === null || b === null) return left;
      return Math.max(0, left + (b - a));
    }

    tick() {
      const now = Date.now();
      if (this.ends - now <= 0) return this.finish();
      const s = Math.floor(this.wallLeft(now) / 1000);
      const d = Math.floor(s / 86400);
      const hh = Math.floor((s % 86400) / 3600);
      const mm = Math.floor((s % 3600) / 60);
      const ss = s % 60;
      if (this.cells.days) this.cells.days.textContent = String(d);
      if (this.cells.hours) this.cells.hours.textContent = pad(hh);
      if (this.cells.minutes) this.cells.minutes.textContent = pad(mm);
      if (this.cells.seconds) this.cells.seconds.textContent = pad(ss);

      if (this.labels.days) this.labels.days.textContent = unitWord('day', d);
      if (this.labels.hours) this.labels.hours.textContent = unitWord('hour', hh);
      if (this.labels.minutes) this.labels.minutes.textContent = unitWord('minute', mm);
      if (this.labels.seconds) this.labels.seconds.textContent = unitWord('second', ss);
    }
  }

  const boot = () => document.querySelectorAll('[data-sale-countdown]').forEach((el) => {
    if (!el.countdown) el.countdown = new Countdown(el);
  });
  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();
})();
